export const Municipality = [
    {
        district_id: 12,
        label: "Sidingba Rural Municipality",
        value: "सिदिङ्वा गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Meringden Rural Municipality",
        value: "मेरिङदेन गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Maiwakhola Rural Municipality",
        value: "मैवाखोला गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Phaktanglung Rural Municipality",
        value: "फक्ताङलुङ गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Sirijangha Rural Municipality",
        value: "सिरीजङ्घा गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Mikwakhola Rural Municipality",
        value: "मिक्वाखोला गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Aathrai Tribeni Rural Municipality",
        value: "आठराई त्रिवेणी गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Pathivara Yangwarak Rural Municipality",
        value: "पाथिभरा याङवरक गाउँपालिका",
    },
    {
        district_id: 12,
        label: "Phungling Municipality",
        value: "फुङलिङ नगरपालिका",
    },
    {
        district_id: 9,
        label: "Makalu Rural Municipality",
        value: "मकालु गाउँपालिका",
    },
    {
        district_id: 9,
        label: "Chichila Rural Municipality",
        value: "चिचिला गाउँपालिका",
    },
    {
        district_id: 9,
        label: "Silichong Rural Municipality",
        value: "सिलिचोंग गाउँपालिका",
    },
    {
        district_id: 9,
        label: "Bhotkhola Rural Municipality",
        value: "भोटखोला गाउँपालिका",
    },
    {
        district_id: 9,
        label: "Sabhapokhari Rural Municipality",
        value: "सभापोखरी गाउँपालिका",
    },
    {
        district_id: 9,
        label: "Dharmadevi Municipality",
        value: "धर्मदेवी नगरपालिका",
    },
    {
        district_id: 9,
        label: "Madi Municipality",
        value: "मादी नगरपालिका",
    },
    {
        district_id: 9,
        label: "Panchakhapan Municipality",
        value: "पाँचखपन नगरपालिका",
    },
    {
        district_id: 9,
        label: "Chainpur Municipality",
        value: "चैनपुर नगरपालिका",
    },
    {
        district_id: 9,
        label: "Khandbari Municipality",
        value: "खाँदबारी नगरपालिका",
    },
    {
        district_id: 10,
        label: "Sotang Rural Municipality",
        value: "सोताङ गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Mahakulung Rural Municipality",
        value: "महाकुलुङ गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Likhu Pike Rural Municipality",
        value: "लिखु पिके गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Necha Salyan Rural Municipality",
        value: "नेचासल्यान गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Thulung Dudhkoshi Rural Municipality",
        value: "थुलुङ दुधकोशी गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Maapya Dudhkoshi Rural Municipality",
        value: "माप्य दुधकोशी गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Khumbu Pasanglahmu Rural Municipality",
        value: "खुम्बु पासाङल्हामु गाउँपालिका",
    },
    {
        district_id: 10,
        label: "Solududhakunda Municipality",
        value: "सोलुदुधकुण्ड नगरपालिका",
    },
    {
        district_id: 7,
        label: "Likhu Rural Municipality",
        value: "लिखु गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Molung Rural Municipality",
        value: "मोलुङ गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Sunkoshi Rural Municipality",
        value: "सुनकोशी गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Champadevi Rural Municipality",
        value: "चम्पादेवी गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Chisankhugadhi Rural Municipality",
        value: "चिशंखुगढी गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Khijidemba Rural Municipality",
        value: "खिजीदेम्वा गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Manebhanjyang Rural Municipality",
        value: "मानेभञ्ज्याङ्ग गाउँपालिका",
    },
    {
        district_id: 7,
        label: "Siddhicharan Municipality",
        value: "सिद्धिचरण नगरपालिका",
    },
    {
        district_id: 5,
        label: "Sakela Rural Municipality",
        value: "साकेला गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Khotehang Rural Municipality",
        value: "खोटेहाङ गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Barahapokhari Rural Municipality",
        value: "बराहपोखरी गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Ainselukharka Rural Municipality",
        value: "ऐसेलुखर्क गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Rawa Besi Rural Municipality",
        value: "रावा बेसी गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Kepilasagadhi Rural Municipality",
        value: "केपिलासगढी गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Jantedhunga Rural Municipality",
        value: "जन्तेढुङ्गा गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Diprung Chuichumma Rural Municipality",
        value: "दिप्रुङ चुइचुम्मा गाउँपालिका",
    },
    {
        district_id: 5,
        label: "Halesi Tuwachung Municipality",
        value: "हलेसी तुवाचुङ नगरपालिका",
    },
    {
        district_id: 5,
        label: "Diktel Rupakot Majhuwagadhi Municipality",
        value: "दिक्तेल रुपाकोट मझुवागढी नगरपालिका",
    },
    {
        district_id: 1,
        label: "Arun Rural Municipality",
        value: "अरुण गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Aamchowk Rural Municipality",
        value: "आमचोक गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Hatuwagadhi Rural Municipality",
        value: "हतुवागढी गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Pauwadungma Rural Municipality",
        value: "पौवादुङमा गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Temkemaiyung Rural Municipality",
        value: "टेम्केमैयुङ गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Salpasilichho Rural Municipality",
        value: "साल्पासिलिछो गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Ramprasad Rai Rural Municipality",
        value: "रामप्रसादराई गाउँपालिका",
    },
    {
        district_id: 1,
        label: "Shadananda Municipality",
        value: "षडानन्द नगरपालिका",
    },
    {
        district_id: 1,
        label: "Bhojpur Municipality",
        value: "भोजपुर नगरपालिका",
    },
    {
        district_id: 2,
        label: "Chaubise Rural Municipality",
        value: "चौबिसे गाउँपालिका",
    },
    {
        district_id: 2,
        label: "Shahidbhumi Rural Municipality",
        value: "सहिदभूमि गाउँपालिका",
    },
    {
        district_id: 2,
        label: "Sangurigadhi Rural Municipality",
        value: "साँगुरीगढी गाउँपालिका",
    },
    {
        district_id: 2,
        label: "Chhathar Jorpati Rural Municipality",
        value: "छथर जोरपाटी गाउँपालिका",
    },
    {
        district_id: 2,
        label: "Pakhribas Municipality",
        value: "पाख्रिबास नगरपालिका",
    },
    {
        district_id: 2,
        label: "Mahalaxmi Municipality",
        value: "महालक्ष्मी नगरपालिका",
    },
    {
        district_id: 2,
        label: "Dhankuta Municipality",
        value: "धनकुटा नगरपालिका",
    },
    {
        district_id: 13,
        label: "Chhathar Rural Municipality",
        value: "छथर गाउँपालिका",
    },
    {
        district_id: 13,
        label: "Phedap Rural Municipality",
        value: "फेदाप गाउँपालिका",
    },
    {
        district_id: 13,
        label: "Aathrai Rural Municipality",
        value: "आठराई गाउँपालिका",
    },
    {
        district_id: 13,
        label: "Menchayam Rural Municipality",
        value: "मेन्छयायेम गाउँपालिका",
    },
    {
        district_id: 13,
        label: "Laligurans Municipality",
        value: "लालीगुराँस नगरपालिका",
    },
    {
        district_id: 13,
        label: "Myanglung Municipality",
        value: "म्याङलुङ नगरपालिका",
    },
    {
        district_id: 8,
        label: "Yangwarak Rural Municipality",
        value: "याङवरक गाउँपालिका",
    },
    {
        district_id: 8,
        label: "Hilihang Rural Municipality",
        value: "हिलिहाङ गाउँपालिका",
    },
    {
        district_id: 8,
        label: "Phalelung Rural Municipality",
        value: "फालेलुङ गाउँपालिका",
    },
    {
        district_id: 8,
        label: "Tumbewa Rural Municipality",
        value: "तुम्वेवा गाउँपालिका",
    },
    {
        district_id: 8,
        label: "Kummayak Rural Municipality",
        value: "कुम्मायक गाउँपालिका",
    },
    {
        district_id: 8,
        label: "Miklajung Rural Municipality",
        value: "मिक्लाजुङ गाउँपालिका",
    },

    {
        district_id: 8,
        label: "Phidim Municipality",
        value: "फिदिम नगरपालिका",
    },
    {
        district_id: 3,
        label: "Rong Rural Municipality",
        value: "रोङ गाउँपालिका",
    },
    {
        district_id: 3,
        label: "Mangsebung Rural Municipality",
        value: "माङसेबुङ गाउँपालिका",
    },
    {
        district_id: 3,
        label: "Chulachuli Rural Municipality",
        value: "चुलाचुली गाउँपालिका",
    },
    {
        district_id: 3,
        label: "Sandakpur Rural Municipality",
        value: "सन्दकपुर गाउँपालिका",
    },
    {
        district_id: 3,
        label: "Fakphokthum Rural Municipality",
        value: "फाकफोकथुम गाउँपालिका",
    },
    {
        district_id: 3,
        label: "Maijogmai Rural Municipality",
        value: "माईजोगमाई गाउँपालिका",
    },
    {
        district_id: 3,
        label: "Illam Municipality",
        value: "इलाम नगरपालिका",
    },
    {
        district_id: 3,
        label: "Mai Municipality",
        value: "माई नगरपालिका",
    },
    {
        district_id: 3,
        label: "Deumai Municipality",
        value: "देउमाई नगरपालिका",
    },
    {
        district_id: 3,
        label: "Suryodaya Municipality",
        value: "सुर्योदय नगरपालिका",
    },
    {
        district_id: 4,
        label: "Kamal Rural Municipality",
        value: "कमल गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Jhapa Rural Municipality",
        value: "झापा गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Kachankawal Rural Municipality",
        value: "कचनकवल गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Gauriganj Rural Municipality",
        value: "गौरीगङ्गा गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Barhadashi Rural Municipality",
        value: "बाह्रदशी गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Haldibari Rural Municipality",
        value: "हल्दीबारी गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Buddhashanti Rural Municipality",
        value: "बुद्धशान्ति गाउँपालिका",
    },
    {
        district_id: 4,
        label: "Shivasataxi Municipality",
        value: "शिवसताक्षी नगरपालिका",
    },
    {
        district_id: 4,
        label: "Bhadrapur Municipality",
        value: "भद्रपुर नगरपालिका",
    },
    {
        district_id: 4,
        label: "Kankai Municipality",
        value: "कनकाई नगरपालिका",
    },
    {
        district_id: 4,
        label: "Birtamod Municipality",
        value: "बिर्तामोड नगरपालिका",
    },
    {
        district_id: 4,
        label: "Mechinagar Municipality",
        value: "मेचीनगर नगरपालिका",
    },
    {
        district_id: 4,
        label: "Damak Municipality",
        value: "दमक नगरपालिका",
    },
    {
        district_id: 4,
        label: "Arjundhara Municipality",
        value: "अर्जुनधारा नगरपालिका",
    },
    {
        district_id: 4,
        label: "Gauradhaha Municipality",
        value: "गौरादह नगरपालिका",
    },
    {
        district_id: 6,
        label: "Jahada Rural Municipality",
        value: "जहदा गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Katahari Rural Municipality",
        value: "कटहरी गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Gramthan Rural Municipality",
        value: "ग्रामथान गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Dhanpalthan Rural Municipality",
        value: "धनपालथान गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Kerabari Rural Municipality",
        value: "केराबारी गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Budhiganga Rural Municipality",
        value: "बुढीगंगा गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Kanepokhari Rural Municipality",
        value: "कानेपोखरी गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Miklajung Rural Municipality",
        value: "मिक्लाजुङ गाउँपालिका",
    },
    {
        district_id: 6,
        label: "Letang Municipality",
        value: "लेटाङ नगरपालिका",
    },
    {
        district_id: 6,
        label: "Sunwarshi Municipality",
        value: "सुनवर्षी नगरपालिका",
    },
    {
        district_id: 6,
        label: "Rangeli Municipality",
        value: "रंगेली नगरपालिका",
    },
    {
        district_id: 6,
        label: "Patahrishanishchare Municipality",
        value: "पथरीशनिश्चरे नगरपालिका",
    },
    {
        district_id: 6,
        label: "Biratnagar Metropolitian City",
        value: "विराटनगर महानगरपालिका",
    },
    {
        district_id: 6,
        label: "Uralabari Municipality",
        value: "उर्लाबारी नगरपालिका",
    },
    {
        district_id: 6,
        label: "Belbari Municipality",
        value: "बेलबारी नगरपालिका",
    },
    {
        district_id: 6,
        label: "Sundarharaicha Municipality",
        value: "सुन्दरहरैँचा नगरपालिका",
    },
    {
        district_id: 6,
        label: "Ratuwamai Municipality",
        value: "रतुवामाई नगरपालिका",
    }, // 12 districts
    {
        district_id: 11,
        label: "Gadhi Rural Municipality",
        value: "गढी गाउँपालिका",
    },
    {
        district_id: 11,
        label: "Koshi Rural Municipality",
        value: "कोशी गाउँपालिका",
    },
    {
        district_id: 11,
        label: "Barju Rural Municipality",
        value: "बर्जु गाउँपालिका",
    },
    {
        district_id: 11,
        label: "Harinagar Rural Municipality",
        value: "हरिनगर गाउँपालिका",
    },
    {
        district_id: 11,
        label: "Dewanganj Rural Municipality",
        value: "देवानगञ्ज गाउँपालिका",
    },
    {
        district_id: 11,
        label: "Bhokraha Narsing Rural Municipality",
        value: "भोक्राहा नरसिंह गाउँपालिका",
    },
    {
        district_id: 11,
        label: "Ramdhuni Municipality",
        value: "रामधुनी नगरपालिका",
    },
    {
        district_id: 11,
        label: "Barahchhetra Municipality",
        value: "बराहक्षेत्र नगरपालिका",
    },
    {
        district_id: 11,
        label: "Duhabi Municipality",
        value: "दुहबी नगरपालिका",
    },
    {
        district_id: 11,
        label: "Inaruwa Municipality",
        value: "इनरुवा नगरपालिका",
    },
    {
        district_id: 11,
        label: "Dharan Sub-Metropolitian City",
        value: "धरान उपमहानगरपालिका",
    },
    {
        district_id: 11,
        label: "Itahari Sub-Metropolitian City",
        value: "इटहरी उपमहानगरपालिका",
    },
    {
        district_id: 14,
        label: "Tapli Rural Municipality",
        value: "ताप्ली गाउँपालिका",
    },
    {
        district_id: 14,
        label: "Rautamai Rural Municipality",
        value: "रौतामाई गाउँपालिका",
    },
    {
        district_id: 14,
        label: "Udayapurgadhi Rural Municipality",
        value: "उदयपुरगढी गाउँपालिका",
    },
    {
        district_id: 14,
        label: "Limchungbung Rural Municipality",
        value: "लिम्चुङबुङ गाउँपालिका",
    },
    {
        district_id: 14,
        label: "Chaudandigadhi Municipality",
        value: "चाैदण्डीगढी नगरपालिका",
    },
    {
        district_id: 14,
        label: "Triyuga Municipality",
        value: "त्रियुगा नगरपालिका",
    },
    {
        district_id: 14,
        label: "Katari Municipality",
        value: "कटारी नगरपालिका",
    },
    {
        district_id: 14,
        label: "Belaka Municipality",
        value: "वेलका नगरपालिका",
    },
    {
        district_id: 20,
        label: "Rajgadh Rural Municipality",
        value: "राजगढ़ गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Rupani Rural Municipality",
        value: "रुपनी गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Tirahut Rural Municipality",
        value: "तिरहुत गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Mahadeva Rural Municipality",
        value: "महादेवा गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Bishnupur Rural Municipality",
        value: "विष्णुपुर गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Chhinnamasta Rural Municipality",
        value: "छिन्नमस्ता गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Balan Bihul Rural Municipality",
        value: "बलान-बिहुल गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Tilathi Koiladi Rural Municipality",
        value: "तिलाठी कोईलाडी गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Agnisair Krishna Savaran Rural Municipality",
        value: "अग्निसाइर कृष्णासवरन गाउँपालिका",
    },
    {
        district_id: 20,
        label: "Hanumannagar Kankalini Municipality",
        value: "हनुमाननगर कंकालिनी नगरपालिका",
    },
    {
        district_id: 20,
        label: "Kanchanrup Municipality",
        value: "कञ्चनरुप नगरपालिका",
    },
    {
        district_id: 20,
        label: "Rajbiraj Municipality",
        value: "राजविराज नगरपालिका",
    },
    {
        district_id: 20,
        label: "Khadak Municipality",
        value: "खडक नगरपालिका",
    },
    {
        district_id: 20,
        label: "Dakneshwori Municipality",
        value: "डाक्नेश्वरी नगरपालिका",
    },
    {
        district_id: 20,
        label: "Saptakoshi Rural Municipality",
        value: "सप्तकोशी नगरपालिका",
    },
    {
        district_id: 20,
        label: "Surunga Municipality",
        value: "सुरुङ्‍गा नगरपालिका",
    },
    {
        district_id: 20,
        label: "Shambhunath Municipality",
        value: "शम्भुनाथ नगरपालिका",
    },
    {
        district_id: 35,
        label: "Panchpokhari Thangpal Rural Municipality",
        value: "पाँचपोखरी थाङपाल गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Chautara SangachokGadhi Municipality",
        value: "चौतारा साँगाचोकगढी नगरपालिका",
    },
    {
        district_id: 35,
        label: "Barhabise Municipality",
        value: "बाह्रबिसे नगरपालिका",
    },
    {
        district_id: 35,
        label: "Melamchi Municipality",
        value: "मेलम्ची नगरपालिका",
    },
    {
        district_id: 33,
        label: "Kalika Rural Municipality",
        value: "कालिका गाउँपालिका",
    },
    {
        district_id: 33,
        label: "Naukunda Rural Municipality",
        value: "नौकुण्ड गाउँपालिका",
    },
    {
        district_id: 33,
        label: "Uttargaya Rural Municipality",
        value: "उत्तरगया गाउँपालिका",
    },
    {
        district_id: 33,
        label: "Gosaikunda Rural Municipality",
        value: "गोसाइँकुण्ड गाउँपालिका",
    },
    {
        district_id: 33,
        label: "Amachodingmo Rural Municipality",
        value: "आमाछोदीङमो गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Gajuri Rural Municipality",
        value: "गजुरी गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Galchi Rural Municipality",
        value: "गल्छी गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Thakre Rural Municipality",
        value: "थाक्रे गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Siddhalek Rural Municipality",
        value: "सिद्धलेक गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Khaniyabash Rural Municipality",
        value: "खनियाबास गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Jwalamukhi Rural Municipality",
        value: "ज्वालामुखी गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Gangajamuna Rural Municipality",
        value: "गंगाजमुना गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Rubi Valley Rural Municipality",
        value: "रुबी उपत्यका गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Tripura Sundari Rural Municipality",
        value: "त्रिपुरासुन्दरी गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Netrawati Dabjong Rural Municipality",
        value: "नेत्रावती डवजोङ गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Benighat Rorang Rural Municipality",
        value: "बेनीघाट रोरंग गाउँपालिका",
    },
    {
        district_id: 25,
        label: "Nilakantha Municipality",
        value: "नीलकण्ठ नगरपालिका",
    },
    {
        district_id: 25,
        label: "Dhunibesi Municipality",
        value: "धुनीबेसी नगरपालिका",
    },
    {
        district_id: 31,
        label: "Kakani Rural Municipality",
        value: "ककनी गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Tadi Rural Municipality",
        value: "टाडी गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Likhu Rural Municipality",
        value: "लिखु गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Myagang Rural Municipality",
        value: "म्यागङ गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Shivapuri Rural Municipality",
        value: "शिवपुरी गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Kispang Rural Municipality",
        value: "किस्पाङ गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Suryagadhi Rural Municipality",
        value: "सुर्यगढी गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Tarkeshwar Rural Municipality",
        value: "तारकेश्वर गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Panchakanya Rural Municipality",
        value: "पञ्चकन्या गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Dupcheshwar Rural Municipality",
        value: "दुप्चेश्वर गाउँपालिका",
    },
    {
        district_id: 31,
        label: "Belkotgadhi Municipality",
        value: "बेलकोटगढी नगरपालिका",
    },
    {
        district_id: 31,
        label: "Bidur Municipality",
        value: "बिदुर नगरपालिका",
    },
    {
        district_id: 27,
        label: "Kirtipur Municipality",
        value: "कीर्तिपुर नगरपालिका",
    },
    {
        district_id: 27,
        label: "Shankharapur Municipality",
        value: "शंखरापुर नगरपालिका",
    },
    {
        district_id: 27,
        label: "Nagarjun Municipality",
        value: "नागार्जुन नगरपालिका",
    },
    {
        district_id: 27,
        label: "Kageshwori Manahora Municipality",
        value: "कागेश्वरी मनोहरा नगरपालिका",
    },
    {
        district_id: 27,
        label: "Dakshinkali Municipality",
        value: "दक्षिणकाली नगरपालिका",
    },
    {
        district_id: 27,
        label: "Budhanilakantha Municipality",
        value: "बूढानीलकण्ठ  नगरपालिका",
    },
    {
        district_id: 27,
        label: "Tarakeshwor Municipality",
        value: "तारकेश्वर नगरपालिका",
    },
    {
        district_id: 27,
        label: "Kathmandu Metropolitian City",
        value: "काठमाडौँ महानगरपालिका",
    },
    {
        district_id: 27,
        label: "Tokha Municipality",
        value: "टोखा नगरपालिका",
    },
    {
        district_id: 27,
        label: "Chandragiri Municipality",
        value: "चन्द्रागिरी नगरपालिका",
    },
    {
        district_id: 27,
        label: "Gokarneshwor Municipality",
        value: "गोकर्णेश्वर नगरपालिका",
    },
    {
        district_id: 23,
        label: "Changunarayan Municipality",
        value: "चाँगुनारायण नगरपालिका",
    },
    {
        district_id: 23,
        label: "Suryabinayak Municipality",
        value: "सूर्यविनायक नगरपालिका",
    },
    {
        district_id: 23,
        label: "Bhaktapur Municipality",
        value: "भक्तपुर नगरपालिका",
    },
    {
        district_id: 23,
        label: "Madhyapur Thimi Municipality",
        value: "मध्यपुर थिमी नगरपालिका",
    },
    {
        district_id: 29,
        label: "Bagmati Rural Municipality",
        value: "बागमती गाउँपालिका",
    },
    {
        district_id: 29,
        label: "Mahankal Rural Municipality",
        value: "महांकाल गाउँपालिका",
    },
    {
        district_id: 29,
        label: "Konjyosom Rural Municipality",
        value: "कोन्ज्योसोम गाउँपालिका",
    },
    {
        district_id: 29,
        label: "Lalitpur Metropolitian City",
        value: "ललितपुर महानगरपालिका",
    },
    {
        district_id: 29,
        label: "Mahalaxmi Municipality",
        value: "महालक्ष्मी नगरपालिका",
    },
    {
        district_id: 29,
        label: "Godawari Municipality",
        value: "गोदावरी नगरपालिका",
    },
    {
        district_id: 28,
        label: "Roshi Rural Municipality",
        value: "रोशी गाउँपालिका",
    },
    {
        district_id: 28,
        label: "Temal Rural Municipality",
        value: "तेमाल गाउँपालिका",
    },
    {
        district_id: 28,
        label: "Bhumlu Rural Municipality",
        value: "भुम्लु गाउँपालिका",
    },
    {
        district_id: 28,
        label: "Mahabharat Rural Municipality",
        value: "महाभारत गाउँपालिका",
    },
    {
        district_id: 28,
        label: "Bethanchowk Rural Municipality",
        value: "बेथानचोक गाउँपालिका",
    },
    {
        district_id: 37,
        label: "Barpak Sulikot Rural Municipality",
        value: "बारपाक सुलिकोट गाउँपालिका",
    },
    {
        district_id: 37,
        label: "Palungtar Municipality",
        value: "पालुङटार  नगरपालिका",
    },
    {
        district_id: 37,
        label: "Gorkha Municipality",
        value: "गोरखा नगरपालिका",
    },
    {
        district_id: 40,
        label: "Chame Rural Municipality",
        value: "चामे गाउँपालिका",
    },
    {
        district_id: 40,
        label: "Narshon Rural Municipality",
        value: "नासोँ  गाउँपालिका",
    },
    {
        district_id: 40,
        label: "Narpa Bhumi Rural Municipality",
        value: "नार्पा भूमि गाउँपालिका",
    },
    {
        district_id: 40,
        label: "Manang Ingshyang Rural Municipality",
        value: "मनाङ ङिस्याङ गाउँपालिका",
    },
    {
        district_id: 41,
        label: "Thasang Rural Municipality",
        value: "थासाङ  गाउँपालिका",
    },
    {
        district_id: 41,
        label: "Gharapjhong Rural Municipality",
        value: "घरपझोङ  गाउँपालिका",
    },
    {
        district_id: 41,
        label: "Lomanthang Rural Municipality",
        value: "लोमान्थाङ गाउँपालिका",
    },
    {
        district_id: 41,
        label: "Lo-Ghekar Damodarkunda Rural Municipality",
        value: "लोकेघर दामोदरकुण्ड गाउँपालिका",
    },
    {
        district_id: 41,
        label: "Waragung Muktikhsetra Rural Municipality",
        value: "वारागुङ मुक्तिक्षेत्र गाउँपालिका",
    },
    {
        district_id: 42,
        label: "Mangala Rural Municipality",
        value: "मंगला गाउँपालिका",
    },
    {
        district_id: 42,
        label: "Malika Rural Municipality",
        value: "मालिका गाउँपालिका",
    },
    {
        district_id: 42,
        label: "Raghuganga Rural Municipality",
        value: "रघुगंगा  गाउँपालिका",
    },
    {
        district_id: 42,
        label: "Dhaulagiri Rural Municipality",
        value: "धौलागिरी  गाउँपालिका",
    },
    {
        district_id: 42,
        label: "Annapurna Rural Municipality",
        value: "अन्नपुर्ण गाउँपालिका",
    },
    {
        district_id: 42,
        label: "Beni Municipality",
        value: "बेनी नगरपालिका",
    },
    {
        district_id: 38,
        label: "Rupa Rural Municipality",
        value: "रुपा गाउँपालिका",
    },
    {
        district_id: 38,
        label: "Madi Rural Municipality",
        value: "माडी गाउँपालिका",
    },
    {
        district_id: 38,
        label: "Annapurna Rural Municipality",
        value: "अन्नपुर्ण  गाउँपालिका",
    },
    {
        district_id: 38,
        label: "Machhapuchchhre Rural Municipality",
        value: "माछापुच्छ्रे  गाउँपालिका",
    },
    {
        district_id: 38,
        label: "Pokhara Metropolitian City",
        value: "पोखरा  महानगरपालिका",
    },
    {
        district_id: 39,
        label: "Dordi Rural Municipality",
        value: "दोर्दी गाउँपालिका",
    },
    {
        district_id: 39,
        label: "Dudhpokhari Rural Municipality",
        value: "दुध पोखरी गाउँपालिका",
    },
    {
        district_id: 39,
        label: "Marsyangdi Rural Municipality",
        value: "मर्स्याङ्दी गाउँपालिका",
    },
    {
        district_id: 39,
        label: "Kwholasothar Rural Municipality",
        value: "क्व्होलासोथार गाउँपालिका",
    },
    {
        district_id: 39,
        label: "Sundarbazar Municipality",
        value: "सुन्दरबजार नगरपालिका",
    },
    {
        district_id: 39,
        label: "Besishahar Municipality",
        value: "बेसीशहर  नगरपालिका",
    },
    {
        district_id: 39,
        label: "Rainas Municipality",
        value: "राईनास नगरपालिका",
    },
    {
        district_id: 39,
        label: "MadhyaNepal Municipality",
        value: "मध्यनेपाल नगरपालिका",
    },
    {
        district_id: 46,
        label: "Ghiring Rural Municipality",
        value: "घिरिङ गाउँपालिका",
    },
    {
        district_id: 46,
        label: "Devghat Rural Municipality",
        value: "देवघाट गाउँपालिका",
    },
    {
        district_id: 46,
        label: "Rhishing Rural Municipality",
        value: "ऋषिङ्ग गाउँपालिका",
    },
    {
        district_id: 46,
        label: "Myagde Rural Municipality",
        value: "म्याग्दे गाउँपालिका",
    },
    {
        district_id: 46,
        label: "Bandipur Rural Municipality",
        value: "बन्दिपुर गाउँपालिका",
    },
    {
        district_id: 46,
        label: "Anbukhaireni Rural Municipality",
        value: "आँबुखैरेनी गाउँपालिका",
    },
    {
        district_id: 46,
        label: "Byas Municipality",
        value: "व्याँस नगरपालिका",
    },
    {
        district_id: 46,
        label: "Shuklagandaki Municipality",
        value: "शुक्लगण्डकी नगरपालिका",
    },
    {
        district_id: 46,
        label: "Bhimad Municipality",
        value: "भिमाद नगरपालिका",
    },
    {
        district_id: 46,
        label: "Bhanu Municipality",
        value: "भानु नगरपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Baudeekali Rural Municipality",
        value: "पूर्व बौदीकाली गाउँपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Bulingtar Rural Municipality",
        value: "पूर्व गाउँपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Hupsekot Rural Municipality",
        value: "पूर्व हमसेकोट गाउँपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Binayee Tribeni Rural Municipality",
        value: "पूर्व विनयी त्रिवेणी गाउँपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Madhyabindu Municipality",
        value: "पूर्व मध्यबिन्दु नगरपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Devchuli Municipality",
        value: "पूर्व देवचुली नगरपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Gaidakot Municipality",
        value: "पूर्व गैंडाकोट नगरपालिका",
    },
    {
        district_id: 43,
        label: "EAST	Kawasoti Municipality",
        value: "पूर्व कावासोती नगरपालिका",
    },
    {
        district_id: 45,
        label: "Harinas Rural Municipality",
        value: "हरिनास गाउँपालिका",
    },
    {
        district_id: 45,
        label: "Biruwa Rural Municipality",
        value: "विरुवा गाउँपालिका",
    },
    {
        district_id: 45,
        label: "Aandhikhola Rural Municipality",
        value: "आँधिखोला गाउँपालिका",
    },
    {
        district_id: 45,
        label: "Phedikhola Rural Municipality",
        value: "फेदीखोला गाउँपालिका",
    },
    {
        district_id: 45,
        label: "Kaligandagi Rural Municipality",
        value: "कालिगण्डकी गाउँपालिका",
    },
    {
        district_id: 45,
        label: "Arjunchaupari Rural Municipality",
        value: "अर्जुनचौपारी गाउँपालिका",
    },
    {
        district_id: 45,
        label: "Putalibazar Municipality",
        value: "पुतलीबजार नगरपालिका",
    },
    {
        district_id: 45,
        label: "Bhirkot Municipality",
        value: "भीरकोट नगरपालिका",
    },
    {
        district_id: 45,
        label: "Galyang Municipality",
        value: "गल्याङ  नगरपालिका",
    },
    {
        district_id: 45,
        label: "Chapakot Municipality",
        value: "चापाकोट नगरपालिका",
    },
    {
        district_id: 45,
        label: "Waling Municipality",
        value: "वालिङ नगरपालिका",
    },
    {
        district_id: 44,
        label: "Modi Rural Municipality",
        value: "मोदी गाउँपालिका",
    },
    {
        district_id: 44,
        label: "Painyu Rural Municipality",
        value: "पैयूँ गाउँपालिका",
    },
    {
        district_id: 44,
        label: "Jaljala Rural Municipality",
        value: "जलजला गाउँपालिका",
    },
    {
        district_id: 44,
        label: "Bihadi Rural Municipality",
        value: "बिहादी गाउँपालिका",
    },
    {
        district_id: 44,
        label: "Mahashila Rural Municipality",
        value: "महाशिला गाउँपालिका",
    },
    {
        district_id: 44,
        label: "Kushma Municipality",
        value: "कुश्मा नगरपालिका",
    },
    {
        district_id: 44,
        label: "Phalebas Municipality",
        value: "फलेवास नगरपालिका",
    },
    {
        district_id: 36,
        label: "Bareng Rural Municipality",
        value: "वरेङ गाउँपालिका",
    },
    {
        district_id: 36,
        label: "Badigad Rural Municipality",
        value: "वडिगाड गाउँपालिका",
    },
    {
        district_id: 36,
        label: "Nisikhola Rural Municipality",
        value: "निसीखोला गाउँपालिका",
    },
    {
        district_id: 36,
        label: "Kanthekhola Rural Municipality",
        value: "काठेखोला गाउँपालिका",
    },
    {
        district_id: 36,
        label: "Tara Khola Rural Municipality",
        value: "ताराखोला गाउँपालिका",
    },
    {
        district_id: 36,
        label: "Taman Khola Rural Municipality",
        value: "तमानखोला गाउँपालिका",
    },
    {
        district_id: 36,
        label: "Jaimuni Municipality",
        value: "जैमिनी नगरपालिका",
    },
    {
        district_id: 36,
        label: "Baglung Municipality",
        value: "बागलुङ नगरपालिका",
    },
    {
        district_id: 36,
        label: "Galkot Municipality",
        value: "गल्कोट नगरपालिका",
    },
    {
        district_id: 36,
        label: "Dhorpatan Municipality",
        value: "ढोरपाटन नगरपालिका",
    },
    {
        district_id: 56,
        label: "EAST	Bhume Rural Municipality",
        value: "पूर्व भूमे गाउँपालिका",
    },
    {
        district_id: 56,
        label: "EAST	Sisne Rural Municipality",
        value: "पूर्व सिस्ने गाउँपालिका",
    },
    {
        district_id: 56,
        label: "EAST	Putha Uttarganga Rural Municipality",
        value: "पूर्व पुथा उत्तरगंगा गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Madi Rural Municipality",
        value: "माडी गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Thawang Rural Municipality",
        value: "थवाङ  गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Sunchhahari Rural Municipality",
        value: "सुनछहरी गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Lungri Rural Municipality",
        value: "लुङ्ग्री गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Gangadev Rural Municipality",
        value: "गंगादेव गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Tribeni Rural Municipality",
        value: "त्रिवेणी गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Pariwartan Rural Municipality",
        value: "परिवर्तन गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Runtigadi Rural Municipality",
        value: "रुन्टिगढी गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Sunil Smriti Rural Municipality",
        value: "सुनिल स्मृति गाउँपालिका",
    },
    {
        district_id: 55,
        label: "Rolpa Municipality",
        value: "रोल्पा नगरपालिका",
    },
    {
        district_id: 54,
        label: "Ayirabati Rural Municipality",
        value: "ऐरावती गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Gaumukhi Rural Municipality",
        value: "गौमुखी गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Jhimruk Rural Municipality",
        value: "झिमरुक गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Naubahini Rural Municipality",
        value: "नौबहिनी गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Mandavi Rural Municipality",
        value: "मन्दावी गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Mallarani Rural Municipality",
        value: "मालारानी गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Sarumarani Rural Municipality",
        value: "सरुमारानी गाउँपालिका",
    },
    {
        district_id: 54,
        label: "Pyuthan Municipality",
        value: "प्युठान नगरपालिका",
    },
    {
        district_id: 54,
        label: "Sworgadwary Municipality",
        value: "स्वर्गद्वारी नगरपालिका",
    },
    {
        district_id: 51,
        label: "Ruru Rural Municipality",
        value: "रूरू गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Isma Rural Municipality",
        value: "इस्मा गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Madane Rural Municipality",
        value: "मदाने गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Malika Rural Municipality",
        value: "मालिाक गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Chatrakot Rural Municipality",
        value: "छत्रकोट गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Dhurkot Rural Municipality",
        value: "धुर्कोट गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Satyawati Rural Municipality",
        value: "सत्यवती गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Chandrakot Rural Municipality",
        value: "चन्द्रकोट गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Kaligandaki Rural Municipality",
        value: "कालिगण्डकी गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Gulmidarbar Rural Municipality",
        value: "गुल्मी दरबार गाउँपालिका",
    },
    {
        district_id: 51,
        label: "Resunga Municipality",
        value: "रेसुङगा नगरपालिका",
    },
    {
        district_id: 51,
        label: "Musikot Municipality",
        value: "मुसिकोट नगरपालिका",
    },
    {
        district_id: 47,
        label: "Panini Rural Municipality",
        value: "पाणिनी गाउँपालिका",
    },
    {
        district_id: 47,
        label: "Chhatradev Rural Municipality",
        value: "छत्रदेव गाउँपालिका",
    },
    {
        district_id: 47,
        label: "Malarani Rural Municipality",
        value: "मालारानी गाउँपालिका",
    },
    {
        district_id: 47,
        label: "Bhumekasthan Municipality",
        value: "भूमिकास्थान नगरपालिका",
    },
    {
        district_id: 47,
        label: "Sitganga Municipality",
        value: "सीतगंगा नगरपालिका",
    },
    {
        district_id: 47,
        label: "Sandhikharka Municipality",
        value: "सन्धिखर्क नगरपालिका",
    },
    {
        district_id: 52,
        label: "Rambha Rural Municipality",
        value: "रम्भा गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Tinau Rural Municipality",
        value: "तिनाउ गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Nisdi Rural Municipality",
        value: "निस्दी गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Mathagadhi Rural Municipality",
        value: "माथागढी गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Ribdikot Rural Municipality",
        value: "रिब्दीकोट गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Purbakhola Rural Municipality",
        value: "पूर्वखोला गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Bagnaskali Rural Municipality",
        value: "वगनासकालीगाउँपालिका",
    },
    {
        district_id: 52,
        label: "Rainadevi Chhahara Rural Municipality",
        value: "रैनादेवी छहरा गाउँपालिका",
    },
    {
        district_id: 52,
        label: "Tansen Municipality",
        value: "तानसेन नगरपालिका",
    },
    {
        district_id: 52,
        label: "Rampur Municipality",
        value: "रामपुर नगरपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Sarawal Rural Municipality",
        value: "पश्चिम सरावल गाउँपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Susta Rural Municipality",
        value: "पश्चिम सुस्ता गाउँपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Pratappur Rural Municipality",
        value: "पश्चिम प्रतापपुर गाउँपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Palhi Nandan Rural Municipality",
        value: "पश्चिम पाल्हिनन्दन गाउँपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Bardaghat Municipality",
        value: "पश्चिम बर्दघाट नगरपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Sunwal Municipality",
        value: "पश्चिम सुनवल नगरपालिका",
    },
    {
        district_id: 43,
        label: "WEST	Ramgram Municipality",
        value: "पश्चिम रामग्राम नगरपालिका",
    },
    {
        district_id: 50,
        label: "Kanchan Rural Municipality",
        value: "कञ्चन गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Siyari Rural Municipality",
        value: "सियारी गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Rohini Rural Municipality",
        value: "रोहिणी गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Gaidahawa Rural Municipality",
        value: "गैडहवा गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Omsatiya Rural Municipality",
        value: "ओम्साटिया गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Sudhdhodhan Rural Municipality",
        value: "शुद्धोधन गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Mayadevi Rural Municipality",
        value: "मायादेवी गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Marchawari Rural Municipality",
        value: "मर्चवारी गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Kotahimai Rural Municipality",
        value: "कोटाहिमाई गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Sammarimai Rural Municipality",
        value: "सम्मरैई गाउँपालिका",
    },
    {
        district_id: 50,
        label: "Butwal Sub-Metropolitian City",
        value: "बुटवल उपमहानगरपालिका",
    },
    {
        district_id: 50,
        label: "Lumbini Sanskritik Municipality",
        value: "लुम्बिनी सांस्कृतिक नगरपालिका",
    },
    {
        district_id: 50,
        label: "Devdaha Municipality",
        value: "देवदह नगरपालिका",
    },
    {
        district_id: 50,
        label: "Sainamaina Municipality",
        value: "सैनामैना नगरपालिका",
    },
    {
        district_id: 50,
        label: "Siddharthanagar Municipality",
        value: "सिद्धार्थनगर नगरपालिका",
    },
    {
        district_id: 50,
        label: "Tillotama Municipality",
        value: "तिलोत्तमा नगरपालिका",
    },
    {
        district_id: 48,
        label: "Yashodhara Rural Municipality",
        value: "यशोधरा गाउँपालिका",
    },
    {
        district_id: 48,
        label: "Bijayanagar Rural Municipality",
        value: "विजयनगर गाउँपालिका",
    },
    {
        district_id: 48,
        label: "Mayadevi Rural Municipality",
        value: "मायादेवी गाउँपालिका",
    },
    {
        district_id: 48,
        label: "Suddhodhan Rural Municipality",
        value: "शुद्धोधन गाउँपालिका",
    },
    {
        district_id: 48,
        label: "Shivaraj Municipality",
        value: "शिवराज नगरपालिका",
    },
    {
        district_id: 48,
        label: "Kapilbastu Municipality",
        value: "कपिलवस्तु नगरपालिका",
    },
    {
        district_id: 48,
        label: "Buddhabhumi Municipality",
        value: "बुद्धभूमि नगरपालिका",
    },
    {
        district_id: 48,
        label: "Maharajgunj Municipality",
        value: "माहाराजगंज नगरपालिका",
    },
    {
        district_id: 48,
        label: "Banganga Municipality",
        value: "वाणगंगा नगरपालिका",
    },
    {
        district_id: 48,
        label: "Krishnanagar Municipality",
        value: "कृष्णनगर नगरपालिका",
    },
    {
        district_id: 53,
        label: "Babai Rural Municipality",
        value: "बबई गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Gadhawa Rural Municipality",
        value: "गढवा गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Rapti Rural Municipality",
        value: "राप्ती गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Rajpur Rural Municipality",
        value: "राजपुर गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Dangisharan Rural Municipality",
        value: "दंगीशरण गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Shantinagar Rural Municipality",
        value: "शान्तिनगर गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Banglachuli Rural Municipality",
        value: "बंगलाचुली गाउँपालिका",
    },
    {
        district_id: 53,
        label: "Tulsipur Sub-Metropolitian City",
        value: "तुलसीपुर उपमहानगरपालिका",
    },
    {
        district_id: 53,
        label: "Ghorahi Sub-Metropolitian City",
        value: "घोराही उपमहानगरपालिका",
    },
    {
        district_id: 53,
        label: "Lamahi Municipality",
        value: "लमही नगरपालिका",
    },
    {
        district_id: 57,
        label: "Khajura Rural Municipality",
        value: "खजुरा गाउँपालिका",
    },
    {
        district_id: 57,
        label: "Janki Rural Municipality",
        value: "जानकी गाउँपालिका",
    },
    {
        district_id: 57,
        label: "Baijanath Rural Municipality",
        value: "बैजनाथ गाउँपालिका",
    },
    {
        district_id: 57,
        label: "Duduwa Rural Municipality",
        value: "डुडुवा गाउँपालिका",
    },
    {
        district_id: 57,
        label: "Narainapur Rural Municipality",
        value: "नरैनापुर गाउँपालिका",
    },
    {
        district_id: 57,
        label: "Rapti Sonari Rural Municipality",
        value: "राप्ती-सोनारी गाउँपालिका",
    },
    {
        district_id: 57,
        label: "Kohalpur Municipality",
        value: "कोहलपुर नगरपालिका",
    },
    {
        district_id: 57,
        label: "Nepalgunj Sub-Metropolitian City",
        value: "नेपालगञ्ज उपमहानगरपालिका",
    },
    {
        district_id: 58,
        label: "Geruwa Rural Municipality",
        value: "गेरुवा गाउँपालिका",
    },
    {
        district_id: 58,
        label: "Badhaiyatal Rural Municipality",
        value: "बढैयाताल  गाउँपालिका",
    },
    {
        district_id: 58,
        label: "Thakurbaba Municipality",
        value: "ठाकुरबाबा नगरपालिका",
    },
    {
        district_id: 58,
        label: "Bansagadhi Municipality",
        value: "बाँसगढी नगरपालिका",
    },
    {
        district_id: 58,
        label: "Barbardiya Municipality",
        value: "बारबर्दिया नगरपालिका",
    },
    {
        district_id: 58,
        label: "Rajapur Municipality",
        value: "राजापुर नगरपालिका",
    },
    {
        district_id: 58,
        label: "Madhuwan Municipality",
        value: "मधुवन नगरपालिका",
    },
    {
        district_id: 58,
        label: "Gulariya Municipality",
        value: "गुलरिया नगरपालिका",
    },
    {
        district_id: 60,
        label: "Kaike Rural Municipality",
        value: "काइके गाउँपालिका",
    },
    {
        district_id: 60,
        label: "Jagadulla Rural Municipality",
        value: "जगदुल्ला गाउँपालिका",
    },
    {
        district_id: 60,
        label: "Mudkechula Rural Municipality",
        value: "मुड्केचुला गाउँपालिका",
    },
    {
        district_id: 60,
        label: "Dolpo Buddha Rural Municipality",
        value: "डोल्पो बुद्ध गाउँपालिका",
    },
    {
        district_id: 60,
        label: "Shey Phoksundo Rural Municipality",
        value: "शे फोक्सुण्डो गाउँपालिका",
    },
    {
        district_id: 60,
        label: "Chharka Tangsong Rural Municipality",
        value: "छार्का ताङसोङ गाउँपालिका",
    },
    {
        district_id: 60,
        label: "Tripurasundari Municipality",
        value: "त्रिपुरासुन्दरी नगरपालिका",
    },
    {
        district_id: 60,
        label: "Thuli Bheri Municipality",
        value: "थुली भेरी नगरपालिका",
    },
    {
        district_id: 64,
        label: "Soru Rural Municipality",
        value: "सोरू गाउँपालिका",
    },
    {
        district_id: 64,
        label: "Khatyad Rural Municipality",
        value: "खट्याद गाउँपालिका",
    },
    {
        district_id: 64,
        label: "Mugum Karmarong Rural Municipality",
        value: "मुगुम कार्मारोंग गाउँपालिका",
    },
    {
        district_id: 64,
        label: "Chhayanath Rara Municipality",
        value: "छायानाथ रारा नगरपालिका",
    },
    {
        district_id: 61,
        label: "Simkot Rural Municipality",
        value: "सिमकोट गाउँपालिका",
    },
    {
        district_id: 61,
        label: "Namkha Rural Municipality",
        value: "नाम्खा गाउँपालिका",
    },
    {
        district_id: 61,
        label: "Chankheli Rural Municipality",
        value: "चंखेली गाउँपालिका",
    },
    {
        district_id: 61,
        label: "Tanjakot Rural Municipality",
        value: "ताँजाकोट गाउँपालिका",
    },
    {
        district_id: 61,
        label: "Sarkegad Rural Municipality",
        value: "सर्केगाड गाउँपालिका",
    },
    {
        district_id: 61,
        label: "Adanchuli Rural Municipality",
        value: "अदानचुली गाउँपालिका",
    },
    {
        district_id: 61,
        label: "Kharpunath Rural Municipality",
        value: "खार्पुनाथ  गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Hima Rural Municipality",
        value: "हिमा गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Tila Rural Municipality",
        value: "टीला गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Sinja Rural Municipality",
        value: "सिञ्जा गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Guthichaur Rural Municipality",
        value: "गुठीचौर  गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Tatopani Rural Municipality",
        value: "तातोपानी गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Patrasi Rural Municipality",
        value: "पातारासी गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Kanakasundari Rural Municipality",
        value: "कनकासुन्दरी  गाउँपालिका",
    },
    {
        district_id: 62,
        label: "Chandannath Municipality",
        value: "चन्दन नाथ नगरपालिका",
    },
    {
        district_id: 63,
        label: "Mahawai Rural Municipality",
        value: "महावाई गाउँपालिका",
    },
    {
        district_id: 63,
        label: "Palata Rural Municipality",
        value: "पलता गाउँपालिका",
    },
    {
        district_id: 63,
        label: "Naraharinath Rural Municipality",
        value: "नरहरिनाथ गाउँपालिका",
    },
    {
        district_id: 63,
        label: "Pachaljharana Rural Municipality",
        value: "पचाल झरना गाउँपालिका",
    },
    {
        district_id: 63,
        label: "Subha Kalika Rural Municipality",
        value: "शुभकालिका गाउँपालिका",
    },
    {
        district_id: 63,
        label: "Sanni Tribeni Rural Municipality",
        value: "सन्नी त्रिवेणी गाउँपालिका",
    },
    {
        district_id: 63,
        label: "Khandachakra Municipality",
        value: "खण्डचक्र नगरपालिका",
    },
    {
        district_id: 63,
        label: "Raskot Municipality",
        value: "रसकोट नगरपालिका",
    },
    {
        district_id: 63,
        label: "Tilagufa Municipality",
        value: "तिलागुफा नगरपालिका",
    },
    {
        district_id: 66,
        label: "Bhairabi Rural Municipality",
        value: "भैरवी गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Mahabu Rural Municipality",
        value: "महाबु  गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Gurans Rural Municipality",
        value: "गुराँस गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Naumule Rural Municipality",
        value: "नौमुल गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Bhagawatimai Rural Municipality",
        value: "भगवतीमाई गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Thantikandh Rural Municipality",
        value: "ठाँटीकाँध गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Dungeshwor Rural Municipality",
        value: "डुङ्गेश्वर गाउँपालिका",
    },
    {
        district_id: 66,
        label: "Aathabis Municipality",
        value: "आठबीस नगरपालिका",
    },
    {
        district_id: 66,
        label: "Dullu Municipality",
        value: "दुल्लु नगरपालिका",
    },
    {
        district_id: 66,
        label: "Chamunda Bindrasaini Municipality",
        value: "चामुण्डा बिन्द्रासैनी नगरपालिका",
    },
    {
        district_id: 66,
        label: "Narayan Municipality",
        value: "नारायण नगरपालिका",
    },
    {
        district_id: 67,
        label: "Kuse Rural Municipality",
        value: "कुसे गाउँपालिका",
    },
    {
        district_id: 67,
        label: "Shiwalaya Rural Municipality",
        value: "शिवालय गाउँपालिका",
    },
    {
        district_id: 67,
        label: "Barekot Rural Municipality",
        value: "बारेकोट गाउँपालिका",
    },
    {
        district_id: 67,
        label: "Junichande Rural Municipality",
        value: "जुनिचन्द गाउँपालिका",
    },
    {
        district_id: 67,
        label: "Nalagad Municipality",
        value: "नलगद नगरपालिका",
    },
    {
        district_id: 67,
        label: "Bheri Municipality",
        value: "भेरी नगरपालिका",
    },
    {
        district_id: 67,
        label: "Chhedagad Municipality",
        value: "छेडागढ नगरपालिका",
    },
    {
        district_id: 68,
        label: "WEST	Tribeni Rural Municipality",
        value: "पश्चिम त्रिबेणी गाउँपालिका",
    },
    {
        district_id: 68,
        label: "WEST	Sani Bheri Rural Municipality",
        value: "पश्चिम सानीभेरी गाउँपालिका",
    },
    {
        district_id: 68,
        label: "WEST	Banfikot Rural Municipality",
        value: "पश्चिम बाफिकोट गाउँपालिका",
    },
    {
        district_id: 68,
        label: "WEST	Aathbiskot Municipality",
        value: "पश्चिम आठविसकोट नगरपालिका",
    },
    {
        district_id: 68,
        label: "WEST	Chaurjahari Municipality",
        value: "पश्चिम चौरजहारी नगरपालिका",
    },
    {
        district_id: 68,
        label: "WEST	Musikot Municipality",
        value: "पश्चिम मुसिकोट नगरपालिका",
    },
    {
        district_id: 59,
        label: "Kumakh Rural Municipality",
        value: "कुमाख गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Darma Rural Municipality",
        value: "दार्मा गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Kapurkot Rural Municipality",
        value: "कपुरकोट गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Kalimati Rural Municipality",
        value: "कालिमती गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Tribeni Rural Municipality",
        value: "त्रिबेणी गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Chhatreshwori Rural Municipality",
        value: "छत्रेश्वरी गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Siddha Kumakh Rural Municipality",
        value: "सिद्ध कुमाख गाउँपालिका",
    },
    {
        district_id: 59,
        label: "Sharada Municipality",
        value: "शारदा नगरपालिका",
    },
    {
        district_id: 59,
        label: "Bangad Kupinde Municipality",
        value: "बांगड कुपिन्द नगरपालिका",
    },
    {
        district_id: 59,
        label: "Bagchaur Municipality",
        value: "बागचौर नगरपालिका",
    },
    {
        district_id: 65,
        label: "Chaukune Rural Municipality",
        value: "चौकुने गाउँपालिका",
    },
    {
        district_id: 65,
        label: "Simta Rural Municipality",
        value: "सिम्ता गाउँपालिका",
    },
    {
        district_id: 65,
        label: "Chingad Rural Municipality",
        value: "चिंगद गाउँपालिका",
    },
    {
        district_id: 65,
        label: "Barahtal Rural Municipality",
        value: "बराहताल गाउँपालिका",
    },
    {
        district_id: 65,
        label: "Gurbhakot Municipality",
        value: "गुर्भाकोट नगरपालिका",
    },
    {
        district_id: 65,
        label: "Panchpuri Municipality",
        value: "पञ्चपुरी नगरपालिका",
    },
    {
        district_id: 65,
        label: "Bheriganga Municipality",
        value: "भेरीगंगा नगरपालिका",
    },
    {
        district_id: 65,
        label: "Lekbeshi Municipality",
        value: "लेकवेशी नगरपालिका",
    },
    {
        district_id: 65,
        label: "Birendranagar Municipality",
        value: "वीरेन्द्रनगर नगरपालिका",
    },
    {
        district_id: 73,
        label: "Gaumul Rural Municipality",
        value: "गौमुल गाउँपालिका",
    },
    {
        district_id: 73,
        label: "Himali Rural Municipality",
        value: "हिमाली गाउँपालिका",
    },
    {
        district_id: 73,
        label: "Jagannath Rural Municipality",
        value: "जगन्नाथ गाउँपालिका",
    },
    {
        district_id: 73,
        label: "Khaptad Chhededaha Rural Municipality",
        value: "खप्तड छेडेदह  गाउँपालिका",
    },
    {
        district_id: 73,
        label: "Swami Kartik Khaapar Rural Municipality",
        value: "स्वामीकार्तिक खापर गाउँपालिका",
    },
    {
        district_id: 73,
        label: "Badimalika Municipality",
        value: "बडिमालिका नगरपालिका",
    },
    {
        district_id: 73,
        label: "Tribeni Municipality",
        value: "त्रिवेणी नगरपालिका",
    },
    {
        district_id: 73,
        label: "Budhiganga Municipality",
        value: "बुढीगंगा नगरपालिका",
    },
    {
        district_id: 73,
        label: "Budhinanda Municipality",
        value: "बुढीनन्द नगरपालिका",
    },
    {
        district_id: 72,
        label: "Masta Rural Municipality",
        value: "मस्ता  गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Thalara Rural Municipality",
        value: "थलारा गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Talkot Rural Municipality",
        value: "तालकोट गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Surma Rural Municipality",
        value: "सुर्मा गाउँपालिका",
    },
    {
        district_id: 72,
        label: "SaiPaal Rural Municipality",
        value: "सइपाल गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Durgathali Rural Municipality",
        value: "दुर्गाथली गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Bithadchir Rural Municipality",
        value: "वित्थडचिर  गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Kedarseu Rural Municipality",
        value: "केदारस्यु गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Khaptadchhanna Rural Municipality",
        value: "खप्तडछान्ना गाउँपालिका",
    },
    {
        district_id: 72,
        label: "Chabispathivera Rural Municipality",
        value: "छबिसपाथिभेरा गाउँपालिका",
    },
    {
        district_id: 72,
        label: "JayaPrithivi Municipality",
        value: "जयपृथ्वी नगरपालिका",
    },
    {
        district_id: 72,
        label: "Bungal Municipality",
        value: "बुङ्गल नगरपालिका",
    },
    {
        district_id: 77,
        label: "Lekam Rural Municipality",
        value: "लेकम गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Naugad Rural Municipality",
        value: "नौगाड गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Byas Rural Municipality",
        value: "व्यास गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Dunhu Rural Municipality",
        value: "दुहुन गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Marma Rural Municipality",
        value: "मर्मा  गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Apihimal Rural Municipality",
        value: "अपिहिमाल गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Malikaarjun Rural Municipality",
        value: "मालिकार्जुन गाउँपालिका",
    },
    {
        district_id: 77,
        label: "Mahakali Municipality",
        value: "महाकाली नगरपालिका",
    },
    {
        district_id: 77,
        label: "Shailyashikhar Municipality",
        value: "शैल्यशिखर नगरपालिका",
    },
    {
        district_id: 76,
        label: "Sigas Rural Municipality",
        value: "सिगास  गाउँपालिका",
    },
    {
        district_id: 76,
        label: "Shivanath Rural Municipality",
        value: "शिवनाथ गाउँपालिका",
    },
    {
        district_id: 76,
        label: "Surnaya Rural Municipality",
        value: "सुर्नया गाउँपालिका",
    },
    {
        district_id: 76,
        label: "Dilasaini Rural Municipality",
        value: "डिलासैनी गाउँपालिका",
    },
    {
        district_id: 76,
        label: "Pancheshwar Rural Municipality",
        value: "पञ्चेश्वर गाउँपालिका",
    },
    {
        district_id: 76,
        label: "Dogadakedar Rural Municipality",
        value: "दोगडाकेदार गाउँपालिका",
    },
    {
        district_id: 76,
        label: "Melauli Municipality",
        value: "मेलौली नगरपालिका",
    },
    {
        district_id: 76,
        label: "Dasharathchanda Municipality",
        value: "दशरथचन्द  नगरपालिका",
    },
    {
        district_id: 76,
        label: "Purchaudi Municipality",
        value: "पुर्चौडी नगरपालिका",
    },
    {
        district_id: 76,
        label: "Patan Municipality",
        value: "पाटन नगरपालिका",
    },
    {
        district_id: 75,
        label: "Alital Rural Municipality",
        value: "आलिताल गाउँपालिका",
    },
    {
        district_id: 75,
        label: "Ajaymeru Rural Municipality",
        value: "अजयमेरु गाउँपालिका",
    },
    {
        district_id: 75,
        label: "Bhageshwar Rural Municipality",
        value: "भागेश्वर  गाउँपालिका",
    },
    {
        district_id: 75,
        label: "Nawadurga Rural Municipality",
        value: "नवदुर्गा गाउँपालिका",
    },
    {
        district_id: 75,
        label: "Ganayapdhura Rural Municipality",
        value: "गन्यापधुरा  गाउँपालिका",
    },
    {
        district_id: 75,
        label: "Amargadhi Municipality",
        value: "अमरगढी नगरपालिका",
    },
    {
        district_id: 75,
        label: "Parashuram Municipality",
        value: "परशुराम नगरपालिका",
    },
    {
        district_id: 71,
        label: "Sayal Rural Municipality",
        value: "सायल  गाउँपालिका",
    },
    {
        district_id: 71,
        label: "Adharsha Rural Municipality",
        value: "आदर्श  गाउँपालिका",
    },
    {
        district_id: 71,
        label: "Jorayal Rural Municipality",
        value: "जोरायल गाउँपालिका",
    },
    {
        district_id: 71,
        label: "Badikedar Rural Municipality",
        value: "बडीकेदार गाउँपालिका",
    },
    {
        district_id: 71,
        label: "Purbichauki Rural Municipality",
        value: "पूर्वीचौकी गाउँपालिका",
    },
    {
        district_id: 71,
        label: "K I Singh Rural Municipality",
        value: "के.आई.सिंह गाउँपालिका",
    },
    {
        district_id: 71,
        label: "Bogtan Foodsil Rural Municipality",
        value: "बोगटान फुड्सिल गाउँपालिका",
    },
    {
        district_id: 71,
        label: "Dipayal Silgadi Municipality",
        value: "दिपायल सिलगढी नगरपालिका",
    },
    {
        district_id: 71,
        label: "Shikhar Municipality",
        value: "शिखर नगरपालिका",
    },
    {
        district_id: 70,
        label: "Dhakari Rural Municipality",
        value: "ढकारी गाउँपालिका",
    },
    {
        district_id: 70,
        label: "Mellekh Rural Municipality",
        value: "मेल्लेख  गाउँपालिका",
    },
    {
        district_id: 70,
        label: "Chaurpati Rural Municipality",
        value: "चौरपाटी गाउँपालिका",
    },
    {
        district_id: 70,
        label: "Ramaroshan Rural Municipality",
        value: "रामारोशन गाउँपालिका",
    },
    {
        district_id: 70,
        label: "Turmakhad Rural Municipality",
        value: "तुर्माखाँद गाउँपालिका",
    },
    {
        district_id: 70,
        label: "Bannigadhi Jayagadh Rural Municipality",
        value: "बान्नीगढी जयगढ गाउँपालिका",
    },
    {
        district_id: 70,
        label: "Sanphebagar Municipality",
        value: "साँफेबगर नगरपालिका",
    },
    {
        district_id: 70,
        label: "Mangalsen Municipality",
        value: "मंगलसेन नगरपालिका",
    },
    {
        district_id: 70,
        label: "Kamalbazar Municipality",
        value: "कमलबजार  नगरपालिका",
    },
    {
        district_id: 70,
        label: "Panchadewal Binayak Municipality",
        value: "पञ्चदेवल विनायक नगरपालिका",
    },
    {
        district_id: 69,
        label: "Chure Rural Municipality",
        value: "चुरे गाउँपालिका",
    },
    {
        district_id: 69,
        label: "Janaki Rural Municipality",
        value: "जानकी गाउँपालिका",
    },
    {
        district_id: 69,
        label: "Kailari Rural Municipality",
        value: "कैलारी गाउँपालिका",
    },
    {
        district_id: 69,
        label: "Joshipur Rural Municipality",
        value: "जोशीपुर गाउँपालिका",
    },
    {
        district_id: 69,
        label: "Mohanyal Rural Municipality",
        value: "मोहन्याल गाउँपालिका",
    },
    {
        district_id: 69,
        label: "Bardagoriya Rural Municipality",
        value: "बर्दागोरिया गाउँपालिका",
    },
    {
        district_id: 69,
        label: "Tikapur Municipality",
        value: "टीकापुर नगरपालिका",
    },
    {
        district_id: 69,
        label: "Ghodaghodi Municipality",
        value: "घोडाघोडी नगरपालिका",
    },
    {
        district_id: 69,
        label: "Bhajani Municipality",
        value: "भजनी नगरपालिका",
    },
    {
        district_id: 69,
        label: "Dhangadhi Sub-Metropolitian City",
        value: "धनगढी  उपमहानगरपालिका",
    },
    {
        district_id: 69,
        label: "Gauriganga Municipality",
        value: "गौरीगङ्गा नगरपालिका",
    },
    {
        district_id: 69,
        label: "Godawari Municipality",
        value: "गोदावरी नगरपालिका",
    },
    {
        district_id: 69,
        label: "Lamkichuha Municipality",
        value: "लम्कीचुहा नगरपालिका",
    },
    {
        district_id: 74,
        label: "Beldandi Rural Municipality",
        value: "बेलडाँडी गाउँपालिका",
    },
    {
        district_id: 74,
        label: "Laljhadi Rural Municipality",
        value: "लालझाडी गाउँपालिका",
    },
    {
        district_id: 74,
        label: "Punarbas Municipality",
        value: "पुनर्वास नगरपालिका",
    },
    {
        district_id: 74,
        label: "Krishnapur Municipality",
        value: "कृष्णपुर नगरपालिका",
    },
    {
        district_id: 74,
        label: "Mahakali Municipality",
        value: "महाकाली नगरपालिका",
    },
    {
        district_id: 74,
        label: "Bedkot Municipality",
        value: "बेदकोट नगरपालिका",
    },
    {
        district_id: 74,
        label: "Belauri Municipality",
        value: "बेलौरी नगरपालिका",
    },
    {
        district_id: 74,
        label: "Bhimdatta Municipality",
        value: "भीमदत्त नगरपालिका",
    },
    {
        district_id: 74,
        label: "Shuklaphanta Municipality",
        value: "शुक्लाफाँटा नगरपालिका",
    },
    {
        district_id: 32,
        label: "Manthali Municipality",
        value: "मन्थली नगरपालिका",
    },
    {
        district_id: 32,
        label: "Ramechhap Municipality",
        value: "रामेछाप नगरपालिका",
    },
    {
        district_id: 32,
        label: "Umakunda Rural Municipality",
        value: "उमाकुँण्ड गाउँपालिका",
    },
    {
        district_id: 32,
        label: "Khandadevi Rural Municipality",
        value: "खाँडादेभी गाउँपालिका",
    },
    {
        district_id: 32,
        label: "Doramba Rural Municipality",
        value: "दोरम्वा गाउँपालिका",
    },
    {
        district_id: 32,
        label: "Gokulganga Rural Municipality",
        value: "गोकुलगँगा गाउँपालिका",
    },
    {
        district_id: 32,
        label: "Likhutamakoshi Rural Municipality ",
        value: "लिखु तामाकोशी गाउँपालिका",
    },
    {
        district_id: 32,
        label: "Sunapati Rural Municipality",
        value: "सुनापति गाउँपालिका",
    },
    {
        district_id: 24,
        label: "Bharatpur Metropolitan City",
        value: "महानगरपालिका",
    },
    {
        district_id: 24,
        label: "Kalika Municipality",
        value: "नगरपालिका",
    },
    {
        district_id: 24,
        label: "Bharatpur Metropolitan City",
        value: "भरतपुर महानगरपालिका",
    },
    {
        district_id: 24,
        label: "Kalika Municipality",
        value: "कालिका नगरपालिका",
    },
    {
        district_id: 24,
        label: "Khairahani Municipality",
        value: "खैरहनी नगरपालिका",
    },
    {
        district_id: 24,
        label: "Madi Municipality",
        value: "माडी नगरपालिका",
    },
    {
        district_id: 24,
        label: "Ratnanagar Municipality",
        value: "रत्ननगर नगरपालिका",
    },
    {
        district_id: 24,
        label: "Rapti Municipality",
        value: "राप्ती नगरपालिका",
    },
    {
        district_id: 24,
        label: "Ichchhakamana Rural Municipality",
        value: "इच्छाकामना गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Hetauda Sub-Metropolitan City",
        value: "हेटौँडा उपमहानगरपालिका",
    },
    {
        district_id: 30,
        label: "Thaha Municipality",
        value: "थाहा नगरपालिका",
    },
    {
        district_id: 30,
        label: "Bhimphedi Rural Municipality",
        value: "भीमफेदी गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Makawanpurgadhi Rural Municipality",
        value: "मकवानपुरगढी गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Manahari Rural Municipality",
        value: "मनहरि गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Raksirang Rural Municipality",
        value: "राक्सिराङ्ग गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Bakaiya Rural Municipality",
        value: "बकैया गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Bagmati Rural Municipality",
        value: "बागमती गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Kailash Rural Municipality",
        value: "कैलास गाउँपालिका",
    },
    {
        district_id: 30,
        label: "Indrasarowar Rural Municipality",
        value: "इन्द्रसरोवर गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Kamalamai Municipality",
        value: "कमलामाई नगरपालिका",
    },
    {
        district_id: 34,
        label: "Dudhauli Municipality",
        value: "दुधौली नगरपालिका",
    },
    {
        district_id: 34,
        label: "Sunkoshi Rural Municipality",
        value: "सुनकोशी गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Hariharpur Gadhi Rural Municipality",
        value: "हरिहरपुरगढी गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Tinpatan Rural Municipality",
        value: "तीनपाटन गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Marin Rural Municipality",
        value: "मारिन गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Golanjor Rural Municipality",
        value: "गोलन्जोर गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Phikkal Rural Municipality",
        value: "फिक्कल गाउँपालिका",
    },
    {
        district_id: 34,
        label: "Ghyanglekh Rural Municipality",
        value: "घ्याङलेख गाउँपालिका",
    },
    {
        district_id: 49,
        label: "Bardghat Municipality",
        value: "बर्दघाट नगरपालिका",
    },
    {
        district_id: 49,
        label: "Ramgram Municipality",
        value: "रामग्राम नगरपालिका",
    },
    {
        district_id: 49,
        label: "Sunwal Municipality",
        value: "सुनवल नगरपालिका",
    },
    {
        district_id: 49,
        label: "Susta Rural Municipality",
        value: "सुस्ता गाउँपालिका",
    },
    {
        district_id: 49,
        label: "Palhinandan Rural Municipality",
        value: "पल्हिनंदन गाउँपालिका",
    },
    {
        district_id: 49,
        label: "Pratappur Rural Municipality",
        value: "प्रतापपुर गाउँपालिका",
    },
    {
        district_id: 49,
        label: "Sarawal Rural Municipality",
        value: "सरावल गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Aurahi Rural Municipality",
        value: "औरही गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Naraha Rural Municipality",
        value: "नरहा गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Arnama Rural Municipality",
        value: "अर्नामा गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Bhagawanpur Rural Municipality",
        value: "भगवानपुर गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Nawarajpur Rural Municipality",
        value: "नवराजपुर गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Bishnupur Rural Municipality",
        value: "बिष्णुपुर गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Bariyarpatti Rural Municipality",
        value: "बरियारपट्टी गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Laxmipur Patari Rural Municipality",
        value: "लक्ष्मीपुर पटारी गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Sakhuwanankarkatti Rural Municipality",
        value: "सखुवानन्कारकट्टी गाउँपालिका",
    },
    {
        district_id: 22,
        label: "Mirchaiya Municipality",
        value: "मिर्चैया नगरपालिका",
    },
    {
        district_id: 22,
        label: "Lahan Municipality",
        value: "लहान नगरपालिका",
    },
    {
        district_id: 22,
        label: "Siraha Municipality",
        value: "सिराहा नगरपालिका",
    },
    {
        district_id: 22,
        label: "Dhangadhimai Municipality",
        value: "धनगढीमाई नगरपालिका",
    },
    {
        district_id: 22,
        label: "Kalyanpur Municipality",
        value: "कल्याणपुर नगरपालिका",
    },
    {
        district_id: 22,
        label: "Karjanha Municipality",
        value: "कर्जन्हा नगरपालिका",
    },
    {
        district_id: 22,
        label: "Golbazar Municipality",
        value: "गोलबजार नगरपालिका",
    },
    {
        district_id: 22,
        label: "Sukhipur Municipality",
        value: "सुखिपुर नगरपालिका",
    },
    {
        district_id: 16,
        label: "Aaurahi Rural Municipality",
        value: "औरही गाउँपालिका",
    },
    {
        district_id: 16,
        label: "Dhanauji Rural Municipality",
        value: "धनौजी गाउँपालिका",
    },
    {
        district_id: 16,
        label: "Bateshwor Rural Municipality",
        value: "बटेश्वर गाउँपालिका",
    },
    {
        district_id: 16,
        label: "Janaknandani Rural Municipality",
        value: "जनकनन्दनी गाउँपालिका",
    },
    {
        district_id: 16,
        label: "Lakshminiya Rural Municipality",
        value: "लक्ष्मीनिया गाउँपालिका",
    },
    {
        district_id: 16,
        label: "Mukhiyapatti Musarmiya Rural Municipality",
        value: "मुखियापट्टी मुसहरमिया गाउँपालिका",
    },
    {
        district_id: 16,
        label: "Mithila Bihari Municipality",
        value: "मिथिला बिहारी नगरपालिका",
    },
    {
        district_id: 16,
        label: "Kamala Municipality",
        value: "कमल नगरपालिका",
    },
    {
        district_id: 16,
        label: "Nagarain Municipality",
        value: "नगराईन नगरपालिका",
    },
    {
        district_id: 16,
        label: "Ganeshman Charnath Municipality",
        value: "गणेशमान चारनाथ नगरपालिका",
    },
    {
        district_id: 16,
        label: "Mithila Municipality",
        value: "मिथिला नगरपालिका",
    },
    {
        district_id: 16,
        label: "Dhanusadham Municipality",
        value: "धनुषाधाम नगरपालिका",
    },
    {
        district_id: 16,
        label: "Bideha Municipality",
        value: "बिदेहा नगरपालिका",
    },
    {
        district_id: 16,
        label: "Sabaila Municipality",
        value: "सबैला नगरपालिका",
    },
    {
        district_id: 16,
        label: "Hansapur Municipality",
        value: "हंसपुर नगरपालिका",
    },
    {
        district_id: 16,
        label: "Janakpurdham Sub-Metropolitian City",
        value: "जनकपुरधाम उपमहानगरपालिका",
    },
    {
        district_id: 16,
        label: "Sahidnagar Municipality",
        value: "शहिदनगर नगरपालिका",
    },
    {
        district_id: 16,
        label: "Chhireshwornath Municipality",
        value: "छिरेश्वरनाथ नगरपालिका",
    },
    {
        district_id: 17,
        label: "Pipra Rural Municipality",
        value: "पिपरा गाउँपालिका",
    },
    {
        district_id: 17,
        label: "Sonama Rural Municipality",
        value: "सोनामा गाउँपालिका",
    },
    {
        district_id: 17,
        label: "Samsi Rural Municipality",
        value: "सम्सी गाउँपालिका",
    },
    {
        district_id: 17,
        label: "Ekdanra Rural Municipality",
        value: "एकडारा गाउँपालिका",
    },
    {
        district_id: 17,
        label: "Mahottari Rural Municipality",
        value: "महोत्तरी गाउँपालिका",
    },
    {
        district_id: 17,
        label: "Gaushala Municipality",
        value: "गौशाला नगरपालिका",
    },
    {
        district_id: 17,
        label: "Ramgopalpur Municipality",
        value: "रामगोपालपुर नगरपालिका",
    },
    {
        district_id: 17,
        label: "Aurahi Municipality",
        value: "औरही नगरपालिका",
    },
    {
        district_id: 17,
        label: "Bardibas Municipality",
        value: "बर्दिबास नगरपालिका",
    },
    {
        district_id: 17,
        label: "Bhangaha Municipality",
        value: "भँगाहा नगरपालिका",
    },
    {
        district_id: 17,
        label: "Jaleswor Municipality",
        value: "जलेश्वर नगरपालिका",
    },
    {
        district_id: 17,
        label: "Balwa Municipality",
        value: "बलवा नगरपालिका",
    },
    {
        district_id: 17,
        label: "Manra Siswa Municipality",
        value: "मनरा शिसवा नगरपालिका",
    },
    {
        district_id: 17,
        label: "Matihani Municipality",
        value: "मटिहानी नगरपालिका",
    },
    {
        district_id: 17,
        label: "Loharpatti Municipality",
        value: "लोहारपट्टी नगरपालिका",
    },
    {
        district_id: 21,
        label: "Dhankaul Rural Municipality",
        value: "धनकौल गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Parsa Rural Municipality",
        value: "पर्सा गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Bishnu Rural Municipality",
        value: "विष्णु गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Ramnagar Rural Municipality",
        value: "रामनगर गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Kaudena Rural Municipality",
        value: "कौडेना गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Basbariya Rural Municipality",
        value: "बसबरीया गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Chandranagar Rural Municipality",
        value: "चन्द्र नगर गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Chakraghatta Rural Municipality",
        value: "चक्रघट्टा गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Bramhapuri Rural Municipality",
        value: "ब्रम्हपुरी गाउँपालिका",
    },
    {
        district_id: 21,
        label: "Barahathawa Municipality",
        value: "बरहथवा नगरपालिका",
    },
    {
        district_id: 21,
        label: "Haripur Municipality",
        value: "हरिपुर नगरपालिका",
    },
    {
        district_id: 21,
        label: "Ishworpur Municipality",
        value: "ईश्वरपुर नगरपालिका",
    },
    {
        district_id: 21,
        label: "Lalbandi Municipality",
        value: "लालबन्दी नगरपालिका",
    },
    {
        district_id: 21,
        label: "Malangawa Municipality",
        value: "मलङ्वा नगरपालिका",
    },
    {
        district_id: 21,
        label: "Kabilasi Municipality",
        value: "कबिलासी नगरपालिका",
    },
    {
        district_id: 21,
        label: "Bagmati Municipality",
        value: "बागमती नगरपालिका",
    },
    {
        district_id: 21,
        label: "Hariwan Municipality",
        value: "हरिवन नगरपालिका",
    },
    {
        district_id: 21,
        label: "Balara Municipality",
        value: "बलरा नगरपालिका",
    },
    {
        district_id: 21,
        label: "Haripurwa Municipality",
        value: "हरिपुर्वा  नगरपालिका",
    },
    {
        district_id: 21,
        label: "Godaita Municipality",
        value: "गोडैता नगरपालिका",
    },
    {
        district_id: 19,
        label: "Yemunamai Rural Municipality",
        value: "यमुनामाई गाउँपालिका",
    },
    {
        district_id: 19,
        label: "Durga Bhagwati Rural Municipality",
        value: "दुर्गा भगवती गाउँपालिका",
    },
    {
        district_id: 19,
        label: "Katahariya Municipality",
        value: "कटहरिया नगरपालिका",
    },
    {
        district_id: 19,
        label: "Maulapur Municipality",
        value: "मौलापुर नगरपालिका",
    },
    {
        district_id: 19,
        label: "Madhav Narayan Municipality",
        value: "माधव नारायण नगरपालिका",
    },
    {
        district_id: 19,
        label: "Gaur Municipality",
        value: "गौर नगरपालिका",
    },
    {
        district_id: 19,
        label: "Gujara Municipality",
        value: "गुजरा नगरपालिका",
    },
    {
        district_id: 19,
        label: "Garuda Municipality",
        value: "गरुडा नगरपालिका",
    },
    {
        district_id: 19,
        label: "Ishanath Municipality",
        value: "ईशनाथ नगरपालिका",
    },
    {
        district_id: 19,
        label: "Chandrapur Municipality",
        value: "चन्द्रपुर नगरपालिका",
    },
    {
        district_id: 19,
        label: "Dewahhi Gonahi Municipality",
        value: "देवाही गोनाही नगरपालिका",
    },
    {
        district_id: 19,
        label: "Brindaban Municipality",
        value: "बृन्दावन नगरपालिका",
    },
    {
        district_id: 19,
        label: "Rajpur Municipality",
        value: "राजपुर नगरपालिका",
    },
    {
        district_id: 19,
        label: "Rajdevi Municipality",
        value: "राजदेवी नगरपालिका",
    },
    {
        district_id: 19,
        label: "Gadhimai Municipality",
        value: "गढीमाई नगरपालिका",
    },
    {
        district_id: 19,
        label: "Phatuwa Bijayapur Municipality",
        value: "फतुहा विजयपुर नगरपालिका",
    },
    {
        district_id: 19,
        label: "Baudhimai Municipality",
        value: "बौधीमाई नगरपालिका",
    },
    {
        district_id: 19,
        label: "Paroha Municipality",
        value: "परोहा नगरपालिका",
    },
    {
        district_id: 15,
        label: "Pheta Rural Municipality",
        value: "फेटा गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Devtal Rural Municipality",
        value: "देवतल गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Prasauni Rural Municipality",
        value: "परसौनी गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Suwarna Rural Municipality",
        value: "सुवर्णा गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Baragadhi Rural Municipality",
        value: "बारागढी गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Karaiyamai Rural Municipality",
        value: "करैयामाई गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Parwanipur Rural Municipality",
        value: "परवानीपुर गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Bishrampur Rural Municipality",
        value: "विश्रामपुर गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Adarshkotwal Rural Municipality",
        value: "आदर्श कोटवाल गाउँपालिका",
    },
    {
        district_id: 15,
        label: "Jitpur Simara Sub-Metropolitian City",
        value: "जितपुर-सिमरा उपमहानगरपालिका",
    },
    {
        district_id: 15,
        label: "Kalaiya Sub-Metropolitian City",
        value: "कलैया उपमहानगरपालिका",
    },
    {
        district_id: 15,
        label: "Pacharauta Municipality",
        value: "पचरौता नगरपालिका",
    },
    {
        district_id: 15,
        label: "Nijgadh Municipality",
        value: "निजगढ नगरपालिका",
    },
    {
        district_id: 15,
        label: "Simraungadh Municipality",
        value: "सिम्रौनगढ नगरपालिका",
    },
    {
        district_id: 15,
        label: "Mahagadhimai Municipality",
        value: "महागढीमाई नगरपालिका",
    },
    {
        district_id: 15,
        label: "Kolhabi Municipality",
        value: "कोल्हवी नगरपालिका",
    },
    {
        district_id: 18,
        label: "Thori Rural Municipality",
        value: "ठोरी गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Dhobini Rural Municipality",
        value: "धोबिनी गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Chhipaharmai Rural Municipality",
        value: "छिपहरमाई गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Jirabhawani Rural Municipality",
        value: "जीराभावानी गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Jagarnathpur Rural Municipality",
        value: "जगरनाथपुर गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Kalikamai Rural Municipality",
        value: "कालिकामाई गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Bindabasini Rural Municipality",
        value: "बिन्दवासनी गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Pakahamainpur Rural Municipality",
        value: "पकाहा मैनपुर गाउँपालिका",
    },
    {
        district_id: 18,
        label: "SakhuwaPrasauni Rural Municipality",
        value: "सखुवा पर्सौनी गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Paterwasugauli Rural Municipality",
        value: "पटेर्वा सुगौली गाउँपालिका",
    },
    {
        district_id: 18,
        label: "Birgunj Metropolitian City",
        value: "वीरगंज महानगरपालिका",
    },
    {
        district_id: 18,
        label: "Bahudaramai Municipality",
        value: "बहुदरमाई नगरपालिका",
    },
    {
        district_id: 18,
        label: "Pokhariya Municipality",
        value: "पोखरीया नगरपालिका",
    },
    {
        district_id: 18,
        label: "Parsagadhi Municipality",
        value: "पर्सागाधी नगरपालिका",
    },
    {
        district_id: 26,
        label: "Bigu Rural Municipality",
        value: "बिगु गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Sailung Rural Municipality",
        value: "शैलुङ्ग गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Melung Rural Municipality",
        value: "मेलुङ गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Baiteshwor Rural Municipality",
        value: "बैतेश्वर गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Tamakoshi Rural Municipality",
        value: "तामाकोशी गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Gaurishankar Rural Municipality",
        value: "गौरीशङ्कर गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Kalinchok Rural Municipality",
        value: "कालिञ्चोक गाउँपालिका",
    },
    {
        district_id: 26,
        label: "Jiri Municipality",
        value: "जिरी नगरपालिका",
    },
    {
        district_id: 26,
        label: "Bhimeshwor Municipality",
        value: "भीमेश्वर नगरपालिका",
    },
    {
        district_id: 35,
        label: "Jugal Rural Municipality",
        value: "जुगल गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Balefi Rural Municipality",
        value: "बलेफी गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Sunkoshi Rural Municipality",
        value: "सुनकोशी गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Helambu Rural Municipality",
        value: "हेलम्बु गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Bhotekoshi Rural Municipality",
        value: "भोटेकोशी गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Lisangkhu Pakhar Rural Municipality",
        value: "लिसंखु पाखर गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Indrawati Rural Municipality",
        value: "इन्द्रावती गाउँपालिका",
    },
    {
        district_id: 35,
        label: "Tripurasundari Rural Municipality",
        value: "त्रिपुरासुन्दरी गाउँपालिका",
    },
    {
        district_id: 8,
        label: "Falgunanda Rural Municipality",
        value: "फाल्गुनन्द गाउँपालिका",
    },
];
